import FilteredEllipse from '@/assets/svg/Blur';
import HeadingOne from '@/components/ui/headings/HeadingOne';
import ImgSlider from '@/components/slider/ImgSlider';
import SeriesHeroes from '@/components/screens/SeriesHeroes';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import SeriesShots from '@/components/screens/SeriesShots';
import SocialLinks from '@/components/screens/SocialLinks';
import Overview from '@/components/screens/Overview';
import GamePanel from '@/components/screens/GamePanel';
import { getApiBaseUrl } from '@/utils/utils';
import Loading from '@/components/ui/Loading';

type Props = {
    title: string;
    slides: {
        content: string;
        image: string;
    }[];
    shots: {
        image: string;
    }[];
    social: {
        name: string;
        links: string;
    }[];
    description: string;
    slider: {
        title: string;
        content: string;
        background: string;
        gamelink: string;
        downloadlink: string;
    }[];
};

const Games = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    const [data, setdata] = useState<Props>();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        fetch(`${getApiBaseUrl()}/projects/${id}`)
            .then((response) => response.json())
            .then((data) => setdata(data))
            .catch((error) => console.error('Error fetching projects:', error))
            .finally(() => setLoading(false));
    }, [id]);

    return (
        <div className="w-full h-full">
            <FilteredEllipse className="!top-[-5%] !left-[-20%]" />
            <div className="flex flex-col h-full w-full">
                <div className="xl:mt-[155px] lg:mt-[140px] mt-[125px]">
                    {loading ? (
                        <Loading className="my-10" />
                    ) : (
                        <>
                            <div className="mainContainer">
                                <HeadingOne headOne={data?.title} className="text-center" />
                                <div className="xl:mt-[87px] lg:mt-[82px] md:mt-[70px] sm:mt-[50px] mt-[32px]">
                                    <ImgSlider slides={data?.slides} />
                                    {/* <ImgSlider sliders={data?.slides} /> */}
                                </div>

                                {/* SocialLinks */}
                                <div className="md:mt-[32px] sm:mt-[28px] mt-[24px] flex flex-col items-center">
                                    <p className="lg:text-[24px] md:text-[21] sm:text-[19px] text-[16px] text-main font-bold">
                                        {t('project.page')}
                                    </p>
                                    <ul className="mt-[14px]">
                                        <SocialLinks
                                            social={data?.social_links}
                                            className="flex md:gap-[32px] sm:gap-[24px] gap-[20px]"
                                        />
                                    </ul>
                                </div>

                                {/* Overview */}
                                <div className="head-about lg:rounded-[32px] md:rounded-[28px] sm:rounded-[24px] rounded-[20px] lg:my-[88px] md:my-[75px] sm:my-[65px] my-[60px]">
                                    <div className="lg:py-[80px] md:py-[65px] sm:py-[50px] py-[40px] xl:px-[80px] lg:px-[70px] md:px-[55px] sm:px-[35px] px-[20px]">
                                        <Overview disc={data?.description} />
                                    </div>
                                </div>
                            </div>

                            <SeriesHeroes characters={data?.series_heros} />
                            <SeriesShots shots={data?.project_images} />
                            <GamePanel slider={data?.slider_store || []} />
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Games;
